/**
 * Language of the selected page like en, de, fr, jp, zh
 */
export function usePageLanguage() {
  const language = navigator.language.split('-')[0];
  return language;
}